module.exports = __webpack_public_path__ + "img/pin-builder.87b17bc1.png";